import $ from 'jquery';

const {
  getGATrackingId, logError, getOrgName, getLoggedInUserEmail, getLoggedInUserDepartment,
  getQueryParameters, toPascalCase,
} = require('./bputils').default;

export default class GlobalSiteTag {
  static gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }

  static injectGTagScript() {
    const trackerId = getGATrackingId();
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${trackerId}`;
    $('body').append(scriptTag);

    window.dataLayer = window.dataLayer || [];

    GlobalSiteTag.gtag('js', new Date());

    return trackerId;
  }

  static initializeGlobalSiteTag() {
    try {
      const trackerId = GlobalSiteTag.injectGTagScript();

      const orgName = getOrgName();
      const email = getLoggedInUserEmail();
      const department = getLoggedInUserDepartment();
      const queryParams = getQueryParameters();
      const source = queryParams && queryParams.source ? queryParams.source : 'direct';
      const config = {
        // Set mapping of Custom Dimensions
        custom_map: {
          dimension1: 'Organization',
          dimension2: 'User',
          dimension3: 'Department',
          dimension4: 'Source',
        },
        // Set actual values of Custom Dimensions
        Organization: orgName,
        User: email,
        Department: department,
        Source: source,
        // send_page_view: false, // To prevent sending PageView send this property
      };

      // This will setup gtag config. Moreover, it will also send "pageview" event
      GlobalSiteTag.gtag('config', trackerId, config);
    } catch (err) {
      logError(err);
    }
  }

  static toString(obj) {
    if (typeof obj === 'object') {
      return JSON.stringify(obj);
    }
    return String(obj);
  }

  static gTagEvent(eventCategory, eventAction, eventLabel) {
    try {
      const eventLabelString = GlobalSiteTag.toString(eventLabel);
      const eventInfo = {
        event_category: toPascalCase(eventCategory) || '(not set)',
        event_label: eventLabelString || '(not set)',
        // value: eventValue || '(not set)', // eventValue must be a number. So mostly not useful for Business Pages
      };

      GlobalSiteTag.gtag('event', toPascalCase(eventAction), eventInfo);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('GTag Failed: ', err);
    }
  }

  static initHyperlinkTagging() {
    $('[data-gtag-tracker-desc]').on('mousedown', function onMouseDown(e) {
      const openedIn = (e.which >= 2) ? 'New window/tab' : 'Same window/tab';
      const desc = $(this).data('gtag-tracker-desc');
      GlobalSiteTag.gTagEventGoTo(desc, openedIn);
    });
  }

  static gTagEventGoTo(desc, openedIn = 'Same window/tab') {
    GlobalSiteTag.gTagEvent('Go To', openedIn, desc);
  }
}
